module.exports = __webpack_public_path__ + "static/media/doodle_plus.bbab360b.png";